export default __webpack_public_path__ + "static/media/strips_subscription_guide@3x.f1d32f0a.webp";